export default __webpack_public_path__ + "static/media/chevron-right_white.fcdb09e3.svg";